const dateHelper = {
  getFullYear(): number {
    return new Date().getFullYear();
  },
};

export default dateHelper;
